export default __webpack_public_path__ + "2af18aaafd8aba7bab36df99ab8c0ee5.png";